var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.is_list_available)?_c('v-flex',{attrs:{"xs12":""}},[_c('ScreenerList',{attrs:{"list":_vm.todayList,"is_today":true}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }